import { useLdFlag } from '@renderer/chat/hooks/useLdFlag'
import { useSlackConnected } from '@renderer/hooks/use-connections'

/** "Share to Slack" shows only behind `slack-launchpad` and with a Slack connection that still works. */
export function useCanShareToSlack(): boolean {
  const isEnabled = useLdFlag<boolean>('slack-launchpad', false) === true
  const isConnected = useSlackConnected()
  return isEnabled && isConnected
}
